import { PageContainer } from '@shared/ui';
import {
  CompanyCreateForm,
  CompanyBreadcrumbs,
  type CompanyCreateFormValues,
} from '@features/company';
import { useEffect } from 'react';
import { useBreadcrumbs } from '@shared/lib';
import { useNavigate } from 'react-router';
import { useCreateCompany } from '@entities/company';
import { getTagsByGroupsForCreate } from '@shared/helpers';
// import removed: useGetCities no longer needed here
import { showNotification } from '@shared/utils';
import { useGetActivitySphere } from '@entities/activitySphere';
import { QueryKey } from '@shared/config';
import { useQueryClient } from '@tanstack/react-query';

export const CompanyCreatePage = () => {
  const context = useBreadcrumbs();
  const navigate = useNavigate();

  useEffect(() => {
    if (!context) {
      return;
    }

    context.setBreadcrumb(<CompanyBreadcrumbs subPage='Новая компания' />);

    return () => {
      context.clearBreadcrumb();
    };
  }, []);

  const { mutate: createCompany, isPending } = useCreateCompany();

  const { data: activitySpheres } = useGetActivitySphere();

  const queryClient = useQueryClient();

  const handleSubmit = (values: CompanyCreateFormValues) => {
    createCompany(
      {
        ...values,
        type: values.type || '',
        cityId: Number(values.city),
        managerId: Number(values.manager),
        activitySpheres: getTagsByGroupsForCreate({
          directory: activitySpheres || [],
          selectedDirectory: values.activitySpheres ?? [],
        }),
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [QueryKey.GET_COMPANIES],
          });

          queryClient.invalidateQueries({
            queryKey: [QueryKey.GET_REGIONS],
          });
          queryClient.invalidateQueries({
            queryKey: [QueryKey.GET_ACTIVITY_SPHERE],
          });

          navigate('/company-list');
        },
        onError: error => {
          let message =
            error.response?.data.message || 'Ошибка при создании компании';
          const errors = error.response?.data.data?.errors;

          if (errors?.['region.existing.id'] || errors?.['region.new.name']) {
            message = 'Нельзя выбрать несколько регионов';
          }

          showNotification({
            error,
            variant: 'error',
            message,
          });
        },
      }
    );
  };

  return (
    <PageContainer
      title='Новая компания'
      py={{ base: 8, sm: 16 }}
      maw={1070}
      mx='0'
    >
      <CompanyCreateForm
        handleBack={() => navigate('/company-list')}
        handleSubmit={handleSubmit}
        isLoading={isPending}
        isDisabled={isPending}
      />
    </PageContainer>
  );
};
